'use client';

import { useSubscriptionStatus } from './use-billing';

/**
 * Verifică dacă tenant-ul curent are un anumit modul activat.
 *
 * Pe durata fetch-ului întoarce `hasModule: true` (optimist) ca să nu apară
 * flash-ul de teaser cât subscriptia nu s-a încărcat — același pattern folosit
 * în sidebar.tsx pentru `isModuleLocked`.
 */
export function useHasModule(moduleCode: string): { hasModule: boolean; isLoading: boolean } {
  const { data, isLoading } = useSubscriptionStatus();
  if (isLoading || !data) return { hasModule: true, isLoading };
  // modules.active e deja EFECTIV (gol dacă abonamentul plătit a expirat/fost anulat) — sincron cu backend-ul (entitlement)
  const addons = ((data as any)?.modules?.active || []) as string[];
  return { hasModule: addons.includes(moduleCode), isLoading: false };
}
